var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 1.5C12.7956 1.5 13.5587 1.81607 14.1213 2.37868C14.6839 2.94129 15 3.70435 15 4.5V10.5H9V4.5C9 3.70435 9.31607 2.94129 9.87868 2.37868C10.4413 1.81607 11.2044 1.5 12 1.5ZM16.5 10.5V4.5C16.5 3.30653 16.0259 2.16193 15.182 1.31802C14.3381 0.474106 13.1935 0 12 0C10.8065 0 9.66193 0.474106 8.81802 1.31802C7.97411 2.16193 7.5 3.30653 7.5 4.5V10.5C6.70435 10.5 5.94129 10.8161 5.37868 11.3787C4.81607 11.9413 4.5 12.7044 4.5 13.5V21C4.5 21.7956 4.81607 22.5587 5.37868 23.1213C5.94129 23.6839 6.70435 24 7.5 24H16.5C17.2956 24 18.0587 23.6839 18.6213 23.1213C19.1839 22.5587 19.5 21.7956 19.5 21V13.5C19.5 12.7044 19.1839 11.9413 18.6213 11.3787C18.0587 10.8161 17.2956 10.5 16.5 10.5Z",
    fill: "#1C2026"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedLock);
export default __webpack_public_path__ + "static/media/closed-lock.11d68ec5334309d6689af3666f2fb477.svg";
export { ForwardRef as ReactComponent };